// extracted by mini-css-extract-plugin
module.exports = {"movieGrid":"MovieGrid_movieGrid__10JNt"};